import { Location } from '@angular/common';
import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { ParticipantExtractQuery, ParticipantExtractQueryDefaultValues } from 'src/app/components/reporting/participant-extract-query';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';
import { BranchService } from 'src/app/services/branch.service';
import { ProvinceService } from 'src/app/services/province.service';
import { ReportingService } from 'src/app/services/reporting.service';

@Component({
    selector: 'app-participant-extractr',
    templateUrl: './participant-extractr.component.html',
    styleUrls: ['./participant-extractr.component.scss'],
    standalone: false
})
export class ParticipantExtractrComponent {

  query:ParticipantExtractQuery = ParticipantExtractQueryDefaultValues()
  programs:any[]=[]
  provinces:any[]=[]
  branches:any[]=[]
  filteredBranches:any[]=[]
  pageName = CheckPageAccess.REPORTING
  isLoading=false;
  drpDateRangeValue: string = "1";
  hideCustomeDate:boolean=true

  get isPageMode(): boolean {
    return !this.dialogRef;
  }

  constructor(
    private reportservice: ReportingService,
    private progservice: ApplicationProgramsService,
    private provinceservice: ProvinceService,
    private branchservice: BranchService,
    private location: Location,
    @Optional() private dialogRef: MatDialogRef<ParticipantExtractrComponent> | null
  ) { }

  ngOnInit()
  {
    this.progservice.getProgramsForUserListing().subscribe({
      next: (data) => {
        this.programs=data
      }
    });

    this.provinceservice.getProvinces().subscribe({
      next: (data) => {
        this.provinces = data
      }

    })

    this.branchservice.getBranches().subscribe({
      next: (data) => {
        this.branches = data
      }
    })
  }

  generateParticipantReport()
  {
    this.isLoading = true
      setTimeout(() => {
      this.reportservice.getParticipantExtract(this.query).subscribe({
        next: (response) => {
          const fileUrl = URL.createObjectURL(response)
        window.open(fileUrl);
        },
        error:(err)=>{
          this.isLoading=false
          console.log(err)
        },
        complete:()=>{
          this.isLoading=false
        }
      })
    },2000)
  }

  ondrpDateRangeChange() {
    let startdate = new Date();
    this.hideCustomeDate = true
    switch (this.drpDateRangeValue) {
      case "1":
        startdate.setDate(startdate.getDate() - 30)
        this.query.StartDate = startdate
        this.query.EndDate = new Date()
        break;
      case "2":
        startdate.setDate(startdate.getDate() - 90)
        this.query.StartDate = startdate
        this.query.EndDate = new Date()
        break;
      case "3":
        startdate.setDate(startdate.getDate() - 365)
        this.query.StartDate = startdate
        this.query.EndDate = new Date()
        break;
      case "4":
        this.hideCustomeDate = false;
        break;
    }
  }

  onProvinceDropdownChange()
  {
    this.filteredBranches = this.branches.filter(b=>b.provinceId == this.query.ProvinceId)
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.location.back();
    }
  }
}
